module.exports = __webpack_public_path__ + "img/Newbie_Axe_02_Mage.c1694357.png";